import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

// 403 Forbidden landing page for users whose role does not permit access to
// the current feature (FR-005). Introduced by feature 009-overcalling-data-editing.
export function ForbiddenPage() {
  usePageTitle('Forbidden — Hawkes Bridge');
  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center">
      <h1 className="text-3xl font-bold text-ink mb-2">403 &mdash; Forbidden</h1>
      <p className="text-ink mb-6">
        You do not have permission to view this page. This area is restricted to
        editors and administrators.
      </p>
      <Link to="/dashboard" className="inline-block text-primary-600 hover:text-primary-800 font-medium">
        Back to dashboard
      </Link>
    </div>
  );
}
